import { ApiEndpoints } from "@shared/api/api-endpoints";
import { axApiClient } from "@shared/api/clients/apiClientFactory";
import { QueryStringParameters } from "@shared/api/url-builder";
import { getRemoteUtilityId } from "@shared/utils/getUtilityId";

export const axIncidentApi = {
  getIncidents: async (queryParams: Record<string, any>) => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "ax",
      `incidents`,
      (qs) => {
        qs.push("remote_utility_id", getRemoteUtilityId());
        if (queryParams) {
          Object.entries(queryParams).forEach(([key, value]) => {
            if (
              value !== undefined &&
              value !== null &&
              value !== "" &&
              !(Array.isArray(value) && value.length === 0)
            ) {
              if (Array.isArray(value)) {
                value.forEach((item) => {
                  qs.push(key, item.toString());
                });
              } else {
                qs.push(key, value.toString());
              }
            }
          });
        }
      }
    );
    const response = await axApiClient.get(url);
    return response.data ?? [];
  },

  creatIncident: async (payload: any): Promise<any> => {
    const url = ApiEndpoints.createUrlWithQueryParameters("ax", "incidents");
    const response = await axApiClient.post(url, payload);
    return response.data;
  },

  getAssetList: async (queryParams?: Record<string, any>): Promise<any> => {
    const remoteUtilityId = getRemoteUtilityId();
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "ax",
      "assets",
      (qs: QueryStringParameters) => {
        qs.push("remote_utility_id", remoteUtilityId);
        if (queryParams) {
          Object.entries(queryParams).forEach(([key, value]) => {
            if (
              value !== undefined &&
              value !== null &&
              value !== "" &&
              value !== "all" &&
              value !== 0
            ) {
              qs.push(key, value.toString());
            }
          });
        }
      }
    );

    const response = await axApiClient.get(url);
    return response.data;
  },

  getIncidentTypeOptions: async (): Promise<any> => {
    const url = ApiEndpoints.createUrlWithPathAndQueryVariables(
      "ax",
      "choices",
      ["incident_type"]
    );

    const response = await axApiClient.get(url);
    return response.data.result;
  },

  getIncidentDetail: async (id: string): Promise<any> => {
    const url = ApiEndpoints.createUrlWithPathAndQueryVariables(
      "ax",
      "incident",
      [id]
    );

    const response = await axApiClient.get(url);
    return response.data;
  },

  updateIncident: async (id: string, payload: any): Promise<any> => {
    const url = ApiEndpoints.createUrlWithPathAndQueryVariables(
      "ax",
      "incident",
      [id]
    );
    const response = await axApiClient.patch(url, payload);
    return response.data;
  },
  getIncidentDashboard: async (): Promise<any> => {
    const url = ApiEndpoints.createUrlWithPathAndQueryVariables(
      "ax",
      "incident",
      ["dashboard"],
      (qs: QueryStringParameters) => {
        qs.push("remote_utility_id", getRemoteUtilityId());
      }
    );

    const response = await axApiClient.get(url);
    return response.data.result;
  },
};
